import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/back.svg";
import { ReactComponent as PhoneIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/phone.svg";
import { ReactComponent as MailIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/mail.svg";
import { ReactComponent as WorldIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/world.svg";
import QRIconAsset from "@smartheat/common/png/streamline-icon-qr-code@24x24.png";
import { usePathCreator } from "../Config/useLinkCreator";
import { Header } from "../Header/Header";
import { useConfig } from "../Config/useConfig";
import { QRCodeModal } from "../QRCodeModal/QRCodeModal";

var Container = _styled.div.withConfig({
  displayName: "HelpPage__Container",
  componentId: "sc-1ap77qr-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "HelpPage__Title",
  componentId: "sc-1ap77qr-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

var PagesContainer = _styled.div.withConfig({
  displayName: "HelpPage__PagesContainer",
  componentId: "sc-1ap77qr-2"
})(["padding-top:30px;"]);

var ForwardIcon = _styled(BackIcon).withConfig({
  displayName: "HelpPage__ForwardIcon",
  componentId: "sc-1ap77qr-3"
})(["transform:rotate(180deg);"]);

var PageLink = _styled(Link).withConfig({
  displayName: "HelpPage__PageLink",
  componentId: "sc-1ap77qr-4"
})(["display:flex;justify-content:space-between;align-items:center;padding:0 20px 0 30px;text-decoration:none;color:#222222;font-size:18px;margin-top:20px;&:first{margin-top:0;}"]);

var ContactsContainer = _styled.div.withConfig({
  displayName: "HelpPage__ContactsContainer",
  componentId: "sc-1ap77qr-5"
})(["flex:1;padding-top:50px;"]);

var ContactItemLink = _styled.a.withConfig({
  displayName: "HelpPage__ContactItemLink",
  componentId: "sc-1ap77qr-6"
})(["display:flex;align-items:center;padding:0 20px 0 30px;text-decoration:none;color:#222222;font-size:18px;margin-top:20px;&:first{margin-top:0;}"]);

var QRImage = _styled.img.withConfig({
  displayName: "HelpPage__QRImage",
  componentId: "sc-1ap77qr-7"
})(["display:block;width:24px;height:24px;"]);

var ContactValue = _styled.div.withConfig({
  displayName: "HelpPage__ContactValue",
  componentId: "sc-1ap77qr-8"
})(["margin-left:40px;margin-right:40px;flex:1;"]);

export function HelpPage() {
  var config = useConfig();
  var pathCreator = usePathCreator();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      qrCodeValue = _useState2[0],
      setQRCodeValue = _useState2[1];

  var handleExtLinkClick = function handleExtLinkClick(event) {
    if (config.dummyExternalLinks) {
      event.preventDefault();
      event.stopPropagation();
      setQRCodeValue(event.currentTarget.href);
    }
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/")
  }), /*#__PURE__*/React.createElement(Title, null, "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B?", /*#__PURE__*/React.createElement("br", null), "\u041E\u0437\u043D\u0430\u043A\u043E\u043C\u044C\u0442\u0435\u0441\u044C \u0441 FAQ \u0438\u043B\u0438 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438"), /*#__PURE__*/React.createElement(ContactsContainer, null, /*#__PURE__*/React.createElement(ContactItemLink, {
    href: "tel:+74997041398",
    onClick: handleExtLinkClick
  }, /*#__PURE__*/React.createElement(PhoneIcon, null), /*#__PURE__*/React.createElement(ContactValue, null, "+74997041398"), config.dummyExternalLinks && /*#__PURE__*/React.createElement(QRImage, {
    src: QRIconAsset
  })), /*#__PURE__*/React.createElement(ContactItemLink, {
    href: "mailto:sales@brosk.ru",
    onClick: handleExtLinkClick
  }, /*#__PURE__*/React.createElement(MailIcon, null), /*#__PURE__*/React.createElement(ContactValue, null, "sales@brosk.ru"), config.dummyExternalLinks && /*#__PURE__*/React.createElement(QRImage, {
    src: QRIconAsset
  })), /*#__PURE__*/React.createElement(ContactItemLink, {
    target: "_blank",
    href: "http://brosk.ru/",
    onClick: handleExtLinkClick
  }, /*#__PURE__*/React.createElement(WorldIcon, null), /*#__PURE__*/React.createElement(ContactValue, null, "brosk.ru"), config.dummyExternalLinks && /*#__PURE__*/React.createElement(QRImage, {
    src: QRIconAsset
  }))), /*#__PURE__*/React.createElement(QRCodeModal, {
    value: qrCodeValue,
    onClose: function onClose() {
      return setQRCodeValue(null);
    }
  }));
}